import React from 'react';
import './index.css';

const Technical = (props) => {

    const goBBack = ()=> window.location.reload()

  return (
    <div>
      <p className='tcnical'>We encounter some technical issues while retrieving your file. Please try again</p>

      <section className='eiouty'>
        <button className='goBack' onClick={goBBack}>Go Back</button>
      </section>
    </div>
  )
}

export default Technical;
